import { createStore } from 'effector';

export const $mapLoaded = createStore(false);
$mapLoaded.watch((state) => console.log('$mapLoaded', state));

export const $interactivity = createStore(true);

export const $drawMode = createStore('simple_select');
